import React, { useRef } from "react";

import "../Asociados/asociadosTable.css";

import { ImagePathBuilder } from "helper/tools";
import SkeletonTable from "../Skeleton/SkeletonTable";
//import { handleStatus } from "../../helperFunctions/helpers";
import { CiImageOn } from "react-icons/ci";
import BadgeStatus from "../Asociados/BadgeStatus";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function ProductosTableBig({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <>
      <table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              className="no-sort"
              style={{ width: "70px", paddingLeft: "0px", paddingRight: "0px" }}
            >
              Preview
            </th>
            <th
              scope="col"
              data-column="numProducto"
              style={{ width: "100px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            {/**  <th
              scope="col"
              data-column="sku"
              style={{ width: "160px" }}
              onClick={(event) => handleSort(event)}
            >
              SKU
            </th>
             */}
            <th
              scope="col"
              data-column="nombre"
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>
            {/*
            <th
              scope="col"
              data-column="tags"
              className="no-sort"
              onClick={(event) => handleSort(event)}
            >
              Descripción
            </th>
            <th
              scope="col"
              data-column="tags"
              className="no-sort"
              onClick={(event) => handleSort(event)}
            >
              Tags
            </th>*/}

            <th
              scope="col"
              data-column="marca"
              onClick={(event) => handleSort(event)}
              style={{ width: "150px" }}
            >
              Marca
            </th>

            <th
              scope="col"
              data-column="genero"
              onClick={(event) => handleSort(event)}
              style={{ width: "120px" }}
            >
              Genero
            </th>
            <th
              scope="col"
              data-column="tamaño"
              onClick={(event) => handleSort(event)}
              style={{ width: "120px" }}
            >
              Tamaño
            </th>
            <th
              scope="col"
              data-column="concentracion"
              style={{ width: "140px" }}
              onClick={(event) => handleSort(event)}
            >
              Concentración
            </th>

            <th
              scope="col"
              data-column="activo"
              style={{ width: "80px" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={8} rowCount={4} />}

          {!isLoading &&
            items?.length > 0 &&
            items?.map((item) => {
              const imagePaths = item.productImagePathsString?.split(",") ?? [];
              const imagePath = imagePaths.length > 0 ? imagePaths[0] : "";
              const imageURL = ImagePathBuilder.to(imagePath);

              return (
                <tr key={item.id}>
                  <th scope="row">
                    <a href="#">
                      {imagePath.length === 0 ? (
                        <CiImageOn className="icon" />
                      ) : (
                        <img src={imageURL} alt="" />
                      )}
                    </a>
                  </th>
                  <th
                    scope="row"
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.numProducto ?? ""}
                    </a>
                  </th>
                  {/**  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.sku ?? ""}
                    </a>
                  </td>
                   */}
                  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.nombre ?? ""}
                    </a>
                  </td>
                  <td>{item.marca?.nombre ?? ""}</td>
                  <td>{item.genero?.nombre ?? ""}</td>
                  <td>{item.tamaño?.nombre ?? ""}</td>
                  <td>{item.concentracion?.nombre ?? ""}</td>
                  {/* <td>{item.descripcion ?? ""}</td>
                 <td style={{ width: "100%", height: "100%" }}>
                    <div
                      className=""
                      style={{
                        overflow: "auto",
                        width: "100%",
                      }}
                    >
                      {item.tagsProducto.map((tag) => {
                        return (
                          <>
                            <span className={"badge bg-primary"}>
                              {tag.nombre ?? ""}
                            </span>
                          </>
                        );
                      })}
                    </div>
                  </td>
                   */}

                  <BadgeStatus item={item} />
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
